module.exports = __webpack_public_path__ + "img/banner_icon_1.6399253c.png";